import "../style/exam-result/Exam_Result.css";
import ERSummaryResult from "./ER_ SummaryResult";
// import ER_Chart1 from './ER_Chart1';
import ERChart2 from "./ER_Chart2";
import ERInfo from "./ER_Info";
import ERResultTable from "./ER_ResultTable";
import ERDenotative from "./ٍER_Denotative";

let common_data = [
  {
    id: 1,
    id2: 1,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "future",
    filter: "discounted",
    user_num: 100,
    max_user: 120,
    user_name: "کوروش پایا",
    user_number: "ANDM871230123",
    exam_filter: "none",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 2,
    id2: 2,
    img: "",
    title: "آزمون زیست شناسی دهم",
    // price:458.200,
    price: 340000,
    discounted_price: 306000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "کارشناسی",
    type: "انفرادی",
    time_type: "thisWeek",
    filter: "discounted",
    exam_filter: "live",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_name: "کوروش پایا",
    user_number: "ANDM871230123",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 3,
    id2: 3,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 100000,
    discounted_price: 90000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "future",
    filter: "discounted",
    exam_filter: "live",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_name: "کوروش پایا",
    user_number: "ANDM871230123",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 4,
    id2: 4,
    img: "",
    title: "آزمون روان درمانی اگزیستانسیال",
    // price:458.200,
    price: 200000,
    discounted_price: 180000,
    discount: "",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "live",
    filter: "none",
    exam_filter: "live",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_name: "کوروش پایا",
    user_number: "ANDM871230123",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 5,
    id2: 5,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 200000,
    discounted_price: 180000,
    discount: "",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    time_type: "live",
    type: "گروهی",
    filter: "none",
    exam_filter: "live",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_number: "ANDM871230123",
    user_name: "کوروش پایا",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 6,
    id2: 6,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 200000,
    discounted_price: 180000,
    discount: "",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "thisWeek",
    filter: "none",
    exam_filter: "collegiate",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_number: "ANDM871230123",
    user_name: "کوروش پایا",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 7,
    id2: 7,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 200000,
    discounted_price: 180000,
    discount: "",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "thisWeek",
    filter: "none",
    exam_filter: "collegiate",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_number: "ANDM871230123",
    user_name: "کوروش پایا",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
  {
    id: 8,
    id2: 8,
    img: "",
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 200000,
    discounted_price: 0,
    discount: "100%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    time_type: "future",
    filter: "free",
    exam_filter: "collegiate",
    negetive_point: "دارد",
    question_type: "تشریحی و تستی",
    guide_file: "دارد",
    guide_file_link: "#",
    short_description: "اطلاعاتی بسیار کوتاه در این بخش است",
    exam_timer: 60,
    user_num: 100,
    user_name: "کوروش پایا",
    user_number: "ANDM871230123",
    creator: {
      avatar: "",
      name: "موسسه فرهنگی مصباح نور",
    },
    about:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    time: "21:30",
    descripton: [
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است  برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد",
    ],
    video: "",
    video_cover: "",
    files: [
      [
        {
          id: 1,
          text: "دریافت فایل پی دی اف درس‌های بخش چهارم و پنجم",
          path: "#",
        },
      ],
      [
        {
          id: 1,
          text: "دریافت فایل ویدیویی درس‌های بخش چهارم و پنجم",
          path: "#",
        },
        {
          id: 2,
          text: "دریافت نرم افزار پخش ویدیو",
          path: "#",
        },
      ],
    ],
  },
];

const Exam_Result = ({ ID }) => {
  let info_data;
  for (let i = 0; i < common_data.length; i++) {
    if (common_data[i].id === ID) {
      info_data = common_data[i];
    }
  }
  return (
    <div className="Exam-Result">
      <div className="Exam-Result-Container">
        <div className="Exam-Result-Container-title">کارنامه</div>
        <div className="Exam-Result-Container-line"></div>
        <ERInfo data={info_data} />
        <ERResultTable />
        <div className="Exam-Result-Container-charts">
          <ERChart2 />
        </div>
        <ERDenotative />
        <ERSummaryResult data={info_data} />
      </div>
    </div>
  );
};

export default Exam_Result;
